import { createSlice } from "@reduxjs/toolkit";

const initialStateValues = {
    userRewards: [],
    validRewardsCount: 0,
    loyalityPoints: 0,
    tempLoyalityPoints: 0
};

export const loyaltySlice = createSlice({
    name: "checkout",
    initialState: initialStateValues,
    reducers: {
        updateUserRewards: (state, action) => {
            state.userRewards = action.payload;
        },
        updateValidRewardsCount: (state, action) => {
            state.validRewardsCount = action.payload
        },
        updateLoyalityPoints: (state, action) => {
            state.loyalityPoints = action.payload;
        },
        updateTempLoyalityPoints: (state, action) => {
            state.tempLoyalityPoints = action.payload;
        },
    },
})

export const {
    updateUserRewards,
    updateValidRewardsCount,
    updateLoyalityPoints,
    updateTempLoyalityPoints
} = loyaltySlice.actions;

export const loyaltyReducer = loyaltySlice.reducer;